import React, { useState, useEffect } from "react";
import { Card, Spin, Empty, Typography, Space, Row, Col } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import WorldMap from "react-svg-worldmap";
import './worldmap-fix.css';

const { Title, Text } = Typography;
const antIcon = <LoadingOutlined spin />;

const countryNameMap = {
  AF: 'Afghanistan', GL: 'Greenland', AL: 'Albania', DZ: 'Algeria', AS: 'American Samoa', AD: 'Andorra', AO: 'Angola', AI: 'Anguilla', AQ: 'Antarctica', AG: 'Antigua and Barbuda', AR: 'Argentina', AM: 'Armenia', AW: 'Aruba', AU: 'Australia', AT: 'Austria', AZ: 'Azerbaijan', BS: 'Bahamas', BH: 'Bahrain', BD: 'Bangladesh', BB: 'Barbados', BY: 'Belarus', BE: 'Belgium', BZ: 'Belize', BJ: 'Benin', BM: 'Bermuda', BT: 'Bhutan', BO: 'Bolivia', BA: 'Bosnia and Herzegovina', BW: 'Botswana', BR: 'Brazil', IO: 'British Indian Ocean Territory', BN: 'Brunei', BG: 'Bulgaria', BF: 'Burkina Faso', BI: 'Burundi', KH: 'Cambodia', CM: 'Cameroon', CA: 'Canada', CV: 'Cape Verde', KY: 'Cayman Islands', CF: 'Central African Republic', TD: 'Chad', CL: 'Chile', CN: 'China', CO: 'Colombia', KM: 'Comoros', CD: 'Congo (Democratic Republic)', CG: 'Congo (Republic)', CR: 'Costa Rica', HR: 'Croatia', CU: 'Cuba', CY: 'Cyprus', CZ: 'Czech Republic', DK: 'Denmark', DJ: 'Djibouti', DM: 'Dominica', DO: 'Dominican Republic', EC: 'Ecuador', EG: 'Egypt', SV: 'El Salvador', GQ: 'Equatorial Guinea', ER: 'Eritrea', EE: 'Estonia', SZ: 'Eswatini', ET: 'Ethiopia', FJ: 'Fiji', FI: 'Finland', FR: 'France', GA: 'Gabon', GM: 'Gambia', GE: 'Georgia', DE: 'Germany', GH: 'Ghana', GR: 'Greece', GD: 'Grenada', GT: 'Guatemala', GN: 'Guinea', GW: 'Guinea-Bissau', GY: 'Guyana', HT: 'Haiti', HN: 'Honduras', HU: 'Hungary', IS: 'Iceland', IN: 'India', ID: 'Indonesia', IR: 'Iran', IQ: 'Iraq', IE: 'Ireland', IL: 'Israel', IT: 'Italy', JM: 'Jamaica', JP: 'Japan', JO: 'Jordan', KZ: 'Kazakhstan', KE: 'Kenya', KI: 'Kiribati', KP: 'North Korea', KR: 'South Korea', KW: 'Kuwait', KG: 'Kyrgyzstan', LA: 'Laos', LV: 'Latvia', LB: 'Lebanon', LS: 'Lesotho', LR: 'Liberia', LY: 'Libya', LI: 'Liechtenstein', LT: 'Lithuania', LU: 'Luxembourg', MG: 'Madagascar', MW: 'Malawi', MY: 'Malaysia', MV: 'Maldives', ML: 'Mali', MT: 'Malta', MH: 'Marshall Islands', MR: 'Mauritania', MU: 'Mauritius', MX: 'Mexico', FM: 'Micronesia', MD: 'Moldova', MC: 'Monaco', MN: 'Mongolia', ME: 'Montenegro', MA: 'Morocco', MZ: 'Mozambique', MM: 'Myanmar', NA: 'Namibia', NR: 'Nauru', NP: 'Nepal', NL: 'Netherlands', NZ: 'New Zealand', NI: 'Nicaragua', NE: 'Niger', NG: 'Nigeria', MK: 'North Macedonia', NO: 'Norway', OM: 'Oman', PK: 'Pakistan', PW: 'Palau', PS: 'Palestine', PA: 'Panama', PG: 'Papua New Guinea', PY: 'Paraguay', PE: 'Peru', PH: 'Philippines', PL: 'Poland', PT: 'Portugal', QA: 'Qatar', RO: 'Romania', RU: 'Russia', RW: 'Rwanda', KN: 'Saint Kitts and Nevis', LC: 'Saint Lucia', VC: 'Saint Vincent and the Grenadines', WS: 'Samoa', SM: 'San Marino', ST: 'Sao Tome and Principe', SA: 'Saudi Arabia', SN: 'Senegal', RS: 'Serbia', SC: 'Seychelles', SL: 'Sierra Leone', SG: 'Singapore', SK: 'Slovakia', SI: 'Slovenia', SB: 'Solomon Islands', SO: 'Somalia', ZA: 'South Africa', SS: 'South Sudan', ES: 'Spain', LK: 'Sri Lanka', SD: 'Sudan', SR: 'Suriname', SE: 'Sweden', CH: 'Switzerland', SY: 'Syria', TW: 'Taiwan', TJ: 'Tajikistan', TZ: 'Tanzania', TH: 'Thailand', TL: 'Timor-Leste', TG: 'Togo', TO: 'Tonga', TT: 'Trinidad and Tobago', TN: 'Tunisia', TR: 'Turkey', TM: 'Turkmenistan', TV: 'Tuvalu', UG: 'Uganda', UA: 'Ukraine', AE: 'United Arab Emirates', GB: 'United Kingdom', US: 'United States', UY: 'Uruguay', UZ: 'Uzbekistan', VU: 'Vanuatu', VE: 'Venezuela', VN: 'Vietnam', YE: 'Yemen', ZM: 'Zambia', ZW: 'Zimbabwe',
};

const allCountryCodes = [ /* same as before */ 
  'AF', 'AL', 'GL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CN', 'CO', 'KM', 'CD', 'CG', 'CR', 'HR', 'CU', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET', 'FJ', 'FI', 'FR', 'GA', 'GM', 'GE', 'DE', 'GH', 'GR', 'GD', 'GT', 'GN', 'GW', 'GY', 'HT', 'HN', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IL', 'IT', 'JM', 'JP', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MR', 'MU', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NZ', 'NI', 'NE', 'NG', 'MK', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PL', 'PT', 'QA', 'RO', 'RU', 'RW', 'KN', 'LC', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB', 'SO', 'ZA', 'SS', 'ES', 'LK', 'SD', 'SR', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TO', 'TT', 'TN', 'TR', 'TM', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN', 'YE', 'ZM', 'ZW'
];

const DestinationCountryReport = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const destinationCountryData = data || [];

  const maxUsers = Math.max(...destinationCountryData.map(d => d.total_users), 1);

  const mapData = allCountryCodes.map(code => {
    const found = destinationCountryData.find(item => item.destination === code);
    return {
      country: code.toLowerCase(),
      value: found ?  Number(found.total_users): 0
    };
  });

  const totalSessions = destinationCountryData.reduce((sum, item) => sum + item.total_users, 0);
  const topCountries = [...destinationCountryData].sort((a, b) => b.total_users - a.total_users).slice(0, 5);

  const getColorByValue = (value) => {
    if (value === 0) return '#e5e7eb'; // light gray for no data
    return '#377dff'; // solid blue for countries with data
  };

  //  New useEffect to remove title elements with ": 0 sessions"
useEffect(() => {
  const cleanTooltips = () => {
    const paths = document.querySelectorAll("svg path");

    paths.forEach((path) => {
      const titleEl = path.querySelector("title");
      if (!titleEl) return;

      const titleText = titleEl.textContent || "";
      if (/: 0 sessions/i.test(titleText)) {
        titleEl.remove(); // Remove tooltip
        path.classList.add("no-tooltip"); // Optional: disable pointer events
      }
    });
  };

  const observer = new MutationObserver(() => {
    requestAnimationFrame(cleanTooltips); // Wait for DOM to settle
  });

  const svgRoot = document.querySelector("svg");
  if (svgRoot) {
    observer.observe(svgRoot, { childList: true, subtree: true });
  }

  return () => observer.disconnect();
}, [destinationCountryData]);


  return (
    <Card className="custom-card-graph" title={<Title level={3}>Current users by destination country</Title>}>
      <Spin indicator={antIcon} size="large" spinning={loading}>
        {destinationCountryData.length > 0 ? (
          <div className="worldmap-row">
            <div className="worldmap-sidebar">
              <Title level={3} style={{ marginBottom: 24 }}>{totalSessions.toLocaleString()} - All sessions</Title>
              <Space direction="vertical" style={{ width: '100%' }}>
                {topCountries.map((country, index) => (
                  <div key={index} style={{ marginBottom: 18 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                      <Text>{countryNameMap[country.destination] || country.destination}</Text>
                      <Text strong>{country.total_users.toLocaleString()}</Text>
                    </div>
                    <div className="worldmap-bar-bg">
                      <div
                        className="worldmap-bar"
                        style={{ width: `${(country.total_users / topCountries[0].total_users) * 100}%` }}
                      />
                    </div>
                  </div>
                ))}
              </Space>
            </div>
            <div className="worldmap-wrapper">
              <div style={{ width: "100%",height: "330px", maxWidth: "800px" }}>
             <WorldMap
              key={destinationCountryData.length}
              data={mapData}
              valueSuffix=""
              color="#53aed8"
              // colorFunction={(countryCode, value) => getColorByValue(value)}
              tooltipBgColor="rgba(255, 255, 255, 0.9)"
              tooltipTextColor="#333"
              tooltipBorderColor="#ccc"
              tooltipBorderRadius={4}
              hoverColor="#818cf8"
              // borderColor="#333"
              strokeOpacity={0}
              richTooltip={true}
              size="lg"
              classNameFunction={(countryCode, value) => value === 0 ? 'no-tooltip' : ''}

            />
              </div>
            </div>
          </div>
        ) : (
          <Empty description="No Destination Country data available." />
        )}
      </Spin>
    </Card>
  );
};

export default DestinationCountryReport;